import { UseSuspenseQueryOptions } from '@tanstack/react-query';

import { AnnualReport } from '@/module/AnnualReport/model/AnnualReportTypes';

import { Id, getQueryKey } from '@feature/utils';
import { ValidationStatus } from '@feature/validation';

import * as api from './AnnualReportApi';

const reportKey = getQueryKey('annual-report');

export function getAnnualReportOptions(
  year: number,
  userId: Id | null,
  status: ValidationStatus | null,
  filterAfterAffiliation: boolean,
): UseSuspenseQueryOptions<AnnualReport> {
  return {
    queryKey: reportKey.as(['report', year, userId, status, filterAfterAffiliation]),
    queryFn: () => api.getAnnualReport(year, userId, status, filterAfterAffiliation),
  };
}
